module.exports = __webpack_public_path__ + "teams_icon.3313457b.png";